export const HelpCenterTranslations = {
    newTicket: 'helpCenter.newTicket',
    next: 'helpCenter.newTicket.next',
    cancel: 'helpCenter.newTicket.cancel',
    previous: 'helpCenter.newTicket.previous',
    submit: 'helpCenter.newTicket.submit',
    navigation: {
        back: 'helpCenter.navigation.back'
    },
    step1: {
        title: 'helpCenter.step1.title',
        subtitle: 'helpCenter.step1.subtitle'
    },
    step2: {
        title: 'helpCenter.step2.title',
        subtitle: 'helpCenter.step2.subtitle'
    },
    step3: {
        title: 'helpCenter.step3.title',
        subtitle: 'helpCenter.step3.subtitle',
        noSpecificProduct: 'helpCenter.form.reason.no_specific_product',
    },
    step4: {
        title: 'helpCenter.step4.title',
        subtitle: 'helpCenter.step4.subtitle',
        subject: {
            label: 'helpCenter.step4.subject.label',
            placeholder: 'helpCenter.step4.subject.placeholder',
            legend: 'helpCenter.step4.subject.legend',
            maxChars: 'helpCenter.step4.subject.maxChars'
        },
        description: {
            label: 'helpCenter.step4.description.label',
            placeholder: 'helpCenter.step4.description.placeholder',
            legend: 'helpCenter.step4.description.legend',
            maxChars: 'helpCenter.step4.description.maxChars'
        },
        caseFiles: {
            label: 'helpCenter.step4.caseFiles.label',
            legend: 'helpCenter.step4.caseFiles.legend',
        },
        contactData: {
            title: 'helpCenter.step4.contactData.title',
            description: 'helpCenter.step4.contactData.description',
            email: 'helpCenter.step4.contactData.email',
            phone: 'helpCenter.step4.contactData.phone',
            infoMessage: 'helpCenter.step4.contactData.infoMessage',
            changeAccessMode: 'helpCenter.step4.contactData.changeAccessMode',
            alternativeContact: 'helpCenter.step4.contactData.alternativeContact',
            alternativeEmail: 'helpCenter.step4.contactData.alternativeEmail',
            alternativeEmailPlaceholder: 'helpCenter.step4.contactData.alternativeEmail.placeholder',
            alternativePhone: 'helpCenter.step4.contactData.alternativePhone',
            alternativePhonePlaceholder: 'helpCenter.step4.contactData.alternativePhone.placeholder',
            alternativePhoneLegend: 'helpCenter.step4.contactData.alternativePhone.legend'
        },
        privacyPolicy: {
            label: 'helpCenter.step4.privacyPolicy.label',
            link: 'helpCenter.step4.privacyPolicy.link'
        },
        form: {
            invalidFormat: 'helpCenter.form.error.invalid_format',
            maxEmailChars: 'helpCenter.form.error.max_email_chars',
            maxPhoneChars: 'helpCenter.form.error.max_phone_chars',
            acceptPrivacyPolicy: 'helpCenter.form.error.accept_privacy_policy',
            invalidFileType: 'helpCenter.form.error.invalid_file_type',
            maxFileSize: 'helpCenter.form.error.max_file_size'
        }
    },
    successMessage: 'helpCenter.successMessage',
    cancelModal: {
        title: 'helpCenter.cancelModal.title',
        description: 'helpCenter.cancelModal.description',
        cancelButton: 'helpCenter.cancelModal.cancelButton',
        exitButton: 'helpCenter.cancelModal.exitButton'
    },
    invoiceModal: {
        title: 'helpCenter.invoiceModal.title',
        description: 'helpCenter.invoiceModal.description',
        privateAreaButton: 'helpCenter.invoiceModal.privateAreaButton',
        continueButton: 'helpCenter.invoiceModal.continueButton'
    },
    bankAccountModal: {
        title: 'helpCenter.bankAccountModal.title',
        description: 'helpCenter.bankAccountModal.description',
        privateAreaButton: 'helpCenter.bankAccountModal.privateAreaButton',
        continueButton: 'helpCenter.bankAccountModal.continueButton'
    },
    tpvModal: {
        title: 'helpCenter.tpvModal.title',
        description: 'helpCenter.tpvModal.description',
        privateAreaButton: 'helpCenter.tpvModal.privateAreaButton',
        continueButton: 'helpCenter.tpvModal.continueButton'
    },
    materialModal: {
        title: 'helpCenter.materialModal.title',
        description: 'helpCenter.materialModal.description',
        privateAreaButton: 'helpCenter.materialModal.privateAreaButton',
        continueButton: 'helpCenter.materialModal.continueButton'
    },
    myTickets: {
        title: 'helpCenter.myTickets.title',
        ticketNumber: 'helpCenter.myTickets.ticketNumber',
        back: 'helpCenter.myTickets.back',
        newTicket: 'helpCenter.myTickets.newTicket',
        filters: {
            statusLabel: 'helpCenter.myTickets.filters.statusLabel',
            statusAll: 'helpCenter.myTickets.filters.statusAll',
            sortLabel: 'helpCenter.myTickets.filters.sortLabel',
            sortNewest: 'helpCenter.myTickets.filters.sortNewest',
            sortOldest: 'helpCenter.myTickets.filters.sortOldest',
        },
        emptyState: 'helpCenter.myTickets.emptyState',
        emptyStateResolved: 'helpCenter.myTickets.emptyStateResolved',
        emptyStateInProgress: 'helpCenter.myTickets.emptyStateInProgress',
        emptyStateButton: 'helpCenter.myTickets.emptyStateButton',
        warningMessage: 'helpCenter.myTickets.warningMessage',
        warningMessagePlural: 'helpCenter.myTickets.warningMessagePlural',
    },
    ticketDetail: {
        title: 'helpCenter.ticketDetail.title',
        description: 'helpCenter.ticketDetail.description',
        seeMore: 'helpCenter.ticketDetail.seeMore',
        seeLess: 'helpCenter.ticketDetail.seeLess',
        footer: {
            ticketClosed: 'helpCenter.ticketDetail.footer.ticketClosed',
            newTicketButton: 'helpCenter.ticketDetail.footer.newTicketButton',
            ticketReOpen: 'helpCenter.ticketDetail.footer.ticketReOpen',
            reOpenButton: 'helpCenter.ticketDetail.footer.reOpenButton',
            reOpenNewTicket: 'helpCenter.ticketDetail.footer.reOpenNewTicket',
            understandButton: 'helpCenter.ticketDetail.footer.understandButton'
        },
        timelineStatus: {
            open: 'helpCenter.ticketDetail.timelineStatus.open',
            inProgress: 'helpCenter.ticketDetail.timelineStatus.inProgress',
            waitingForAnswer: 'helpCenter.ticketDetail.timelineStatus.waitingForAnswer',
            resolved: 'helpCenter.ticketDetail.timelineStatus.resolved',
            reopened: 'helpCenter.ticketDetail.timelineStatus.reopened',
            status: 'helpCenter.ticketDetail.timelineStatus.status'
        }
    },
    errorPage: {
        title: 'helpCenter.errorPage.title',
        subtitle: 'helpCenter.errorPage.subtitle',
        description: 'helpCenter.errorPage.description',
        retryButton: 'helpCenter.errorPage.retryButton',
        backButton: 'helpCenter.errorPage.backButton'
    },
    reopenTicket: {
        expandedDescription: {
            label: 'helpCenter.reopenTicket.expandedDescription.label',
            placeholder: 'helpCenter.reopenTicket.expandedDescription.placeholder',
            legend: 'helpCenter.reopenTicket.expandedDescription.legend',
            maxChars: 'helpCenter.reopenTicket.expandedDescription.maxChars'
        },
        cancelModal: {
            title: 'helpCenter.reopenTicket.cancelModal.title',
            description: 'helpCenter.reopenTicket.cancelModal.description',
            cancelButton: 'helpCenter.reopenTicket.cancelModal.cancelButton',
            exitButton: 'helpCenter.reopenTicket.cancelModal.exitButton'
        }
    }
}